import StatusBtn from '../components/atoms/status/StatusBtn.jsx'

const STACK1 = [
	'Photographer/Videographer',
	'Aesthetics',
	'Florist',
	'Planner/Coordinator',
	'Venue',
	'Music',
]

const STACK2 = [
	'Caterer',
	'Baker (Cakes/Desserts)',
	'Stationery/Invitations',
	'Decor/Rentals',
	'Transportation',
	'Photo Booth',
]

const STACK3 = [
	'Lighting/AV',
	'Officiant',
	'Attire',
	'Favours & Gifts',
	'Entertainment',
	'Accommodations',
]

export const STACKS = [STACK1, STACK2, STACK3]
export const ALL_STACKS = STACKS.flat()
export const profilePics = [
	'/images/Photographer-Videographer.svg',
	'/images/Aesthetics.svg',
	'/images/Florist.svg',
	'/images/Planner-cordinator.svg',
	'/images/Venue.svg',
	'/images/Music.svg',
	'/images/Caterer.svg',
	'/images/Baker.svg',
	'/images/Stationery-Invitations.svg',
	'/images/Decor-Rentals.svg',
	'/images/Transportation.svg',
	'/images/Photobooth.svg',
	'/images/Lighting-AV.svg',
	'/images/Officiant.svg',
	'/images/Attire.svg',
	'/images/Favours-Gifts.svg',
	'/images/Entertainment.svg',
	'/images/Accommodations.svg',
]

export const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/i

export const TASK_PRIORITY = [
	{ label: 'High', value: 0 },
	{ label: 'Medium', value: 1 },
	{ label: 'Low', value: 2 },
]

export const TASK_STATUS_OPTIONS = [
	{
		value: 'New',
		label: <StatusBtn label="New" variant="active" />,
	},
	{
		value: 'In Progress',
		label: <StatusBtn label="In Progress" variant="pending" />,
	},
	{
		value: 'Completed',
		label: <StatusBtn label="Completed" variant="submitted" />,
	},
	{
		value: 'Overdue',
		label: <StatusBtn label="Overdue" variant="closed" />,
	},
]

export const WEDDING_ROLES = [
	{ value: 'Groom', label: 'Groom' },
	{ value: 'Bride', label: 'Bride' },
	{ value: 'Marrier', label: 'Marrier' },
]

export const EVENT_CATEGORIES = [
	'Pre-wedding',
	'Post-wedding',
	'Wedding (Party Only)',
	'Wedding (Guests and Party)'
]

export const PACKAGE_PRICE_TYPE_OPTIONS = [
	{ value: 'Fixed', label: 'Fixed' },
	{ value: 'Per Hour', label: 'Per Hour' },
	{ value: 'Per Guest', label: 'Per Guest' },
	{ value: 'Per Location', label: 'Per Location' },
	{ value: 'Request Quote', label: 'Request Quote' },
]

export const ADDON_TYPE_OPTIONS = [
	{ value: 'Custom', label: 'Custom' },
	{ value: 'Travel Fees', label: 'Travel Fees' },
]

export const TAX_PERCENTAGE = 10

export const STEP_FIELDS = {
	1: ['businessTypes', 'customBusinessType'],
	2: ['businessDescription'],
	3: ['numEmployees'],
	4: ['services'],
	5: ['maxCapacity'],
	6: ['media', 'containsImage', 'imageMediaMap'],
	7: ['instagramLink', 'tiktokLink', 'facebookLink', 'websiteLink'],
}

export const statusData =[
	{ status: 'New', label: 'Proposal Request Sent', variant: 'inprogress' },
	{ status: 'Submitted', label: 'Bid Submitted', variant: 'pending' },
	{ status: 'Approved', label: 'Bid Approved', variant: 'completed' },
	{ status: 'Rejected', label: 'Bid Rejected', variant: 'error' },
	{ status: 'Declined', label: 'Bid Declined', variant: 'error' },
	{ status: 'Deleted', label: 'Bid Deleted', variant: 'error' },
	{ status: 'Revision', label: 'Revision Requested', variant: 'revision' },
	{ status: 'In Review', label: 'In Review', variant: 'pending' },
]

export const NotificationHeader = [
	{ title: 'Chat', text: 'New Message' },
	{ title: 'Proposals', text: 'New Proposal Received' },
	{ title: 'bid-request-approved', text: 'Proposal Approved!' },
	{ title: 'bid-request-rejected', text: 'Proposal Rejected' },
	{ title: 'bid-request-submitted', text: 'Proposal Submitted' },
	{ title: 'bid-request-withdraw', text: 'Proposal Withdraw' },
	{ title: 'bid-request-revision', text: 'Proposal Revision' },
	{
		title: 'bid-request-revision-cancelled',
		text: 'Proposal Revision Cancelled',
	},
	{
		title: 'proposal-request-cancellation',
		text: 'Proposal Request Cancellation',
	},
]

export const BUSINESS_PROFILE_TOTAL_STEPS = Object.keys(STEP_FIELDS).length

export const PLAN_DETAILS = {
	user: [
		{
			id: 'free',
			features: {
				included: [
					'Create and manage your wedding',
					'Invite partner',
					'Wedding overview (date, location, key details)',
					'Default planning timeline',
					'Personalized task list with ability to update statuses and assign tasks',
					'Budget tracking',
					'Manage guest list (coming soon)',
					'Browse vendor directory',
					'Send vendor inquiries',
					'Favorite vendors',
					'Chat with vendors',
					'Find a wedding planner (coming soon)',
					'Rate vendors following your wedding',
				],
				not_included: [
					'Custom task creation',
					'Timeline optimization or reminders',
					'Budget vs actuals tracking',
					'Seating charts',
					'Vendor comparison tools',
					'File uploads',
					'Planner collaboration',
				],
			},
		},
		{
			id: 'premium',
			features: {
				includes_all_free: true,
				included: [
					'Unlimited custom tasks',
					'Smart reminders and nudges',
					'Timeline progress indicators',
					'Editable planning structure',
					'Budget vs actual tracking',
					'Category-level budget breakdown',
					'Budget limit alerts',
					'Seating chart builder (coming soon)',
					'Plus-one logic',
					'Guest tagging (dietary, accessibility, family, etc.)',
					'Guest list export',
					'Save and shortlist vendors',
					'Message history with vendors',
					'Notes per vendor (coming soon)',
					'Upload contracts, invoices, and inspiration',
					'Invite unlimited collaborators',
					'Assign tasks to helpers',
					'Calendar sync (Google / iCal) (coming soon)',
				],
			},
			notes: [
				'If a planner is managing your wedding through On Time Bride, premium features are included through the planner.',
				'Couples do not pay separately in this case.',
			],
		},
	],
	vendor: [
		{
			id: 'free',
			features: {
				included: [
					'Public listing in the On Time Bride marketplace',
					'Vendor profile with photo, description, and website link',
					'Appear in search results for your category and region',
					'Receive inquiries from couples (limited messaging)',
					'Access to pay-per-lead marketplace (purchase validated leads as needed)',
					'Reviews from booked couples displayed on your profile',
					'Basic analytics: profile views and favorites',
				],
			},
			best_for:
				'Testing the platform, early-stage vendors, or side-hustle professionals.',
		},
		{
			id: 'business_basics',
			features: {
				includes_all_free: true,
				included: [
					'Plan up to 10 active weddings',
					'Unlimited messaging with couples',
					'CRM-style dashboard for inquiries, bookings, and contracts',
					'Smart calendar and availability management',
					'Built-in invoicing and secure online payments (Stripe)',
					'Task reminders and client follow-ups',
					'Unlimited validated leads per month included',
					'Priority email and chat support',
					'2% platform transaction fee on payments',
				],
			},
			best_for:
				'Active vendors booking multiple weddings per season who want to automate admin and close more deals.',
		},
		{
			id: 'business_pro',
			features: {
				includes_all_business_basics: true,
				included: [
					'Unlimited weddings',
					'Top Vendor placement in search results and email recommendations',
					'"Pro Vendor" badge on profile',
					'Unlimited validated leads per month',
					'Discounted lead prices for additional purchases',
					'Custom branding for proposals and contracts (logo, colors, domain) (coming soon)',
					'Advanced booking analytics (conversion rates, lead source tracking, revenue reports) (coming soon)',
					'VIP customer support with dedicated account manager',
					'0% platform transaction fee on payments',
				],
			},
			best_for:
				'Established vendors, studios, and venues who want top visibility and the most professional presentation possible.',
		},
		{
			id: 'top_badge',
			features: {
				included: [
					'Detailed profile with up to 10 photos',
					'List up to 3 packages (coming soon)',
					'Top label badge on profile',
					'Appear at the top of listings in marketplace',
				],
			},
			best_for: 'Vendors who want maximum visibility and premium status.',
		},
	],

	'kazoo-planner': [
		{
			id: 'free',
			features: {
				included: [
					'Test the wedding planning tools',
					'Public listing in the On Time Bride marketplace',
					'Planner profile with photo, description, and website link',
					'Appear in search results by region',
					'Receive inquiries from couples (limited messaging)',
					'Access to pay-per-lead marketplace',
					'Reviews from booked couples displayed on your profile',
					'Basic analytics: profile views and favorites',
				],
			},
			best_for:
				'Testing the platform, early-stage planners, or part-time planners.',
		},
		{
			id: 'business_basics',
			features: {
				includes_all_free: true,
				included: [
					'Plan up to 10 active weddings',
					'CRM-style dashboard for managing inquiries, bookings, and contracts',
					'Smart calendar and availability management',
					'Built-in invoicing and secure online payments (Stripe)',
					'Task reminders and client follow-ups',
					'Unlimited validated leads per month included',
					'Priority email and chat support',
					'2% platform transaction fee on payments',
				],
			},
			best_for:
				'Active planners managing multiple weddings per season who want to automate admin and streamline workflows.',
		},
		{
			id: 'business_pro',
			features: {
				includes_all_business_basics: true,
				included: [
					'Unlimited weddings',
					'Top Planner placement in search results and email recommendations',
					'"Pro Planner" badge on profile',
					'Unlimited validated leads per month',
					'Discounted lead prices for additional purchases',
					'Custom branding for proposals and contracts (coming soon)',
					'Advanced booking analytics and reporting (coming soon)',
					'VIP customer support with dedicated account manager',
					'0% platform transaction fee on payments',
				],
			},
			best_for:
				'Established planners and studios who want maximum visibility and a premium client experience.',
		},
		{
			id: 'top_badge',
			features: {
				included: [
					'Detailed profile with up to 10 photos',
					'List up to 3 packages (coming soon)',
					'Top label badge on profile',
					'Appear at the top of listings in marketplace',
				],
			},
			best_for:
				'Planners who want maximum visibility and premium status.',
		},
	],
}

export const STAFF_ROLES = ['vendor-staff', 'planner-staff']
export const OTHER_TYPE_TOKEN = '__OTHER_NO_BUSINESS_TYPE__'

